//src/components/rental-managers/SmartLocksSection.jsx


import React from 'react';
import { Box, Typography, Button, Grid, Link } from '@mui/material';
import SmartLocksSectionStyles from './SmartLocksSection.styles';


// funtion to route to products page
const handleShopClick = () => {
  window.location.href = '/smart-locks';
};

const SmartLocksSection = () => {
  return (
    <Box sx={SmartLocksSectionStyles.container}>
      <Grid container spacing={0} alignItems="stretch">
        {/* Left Side - Black Background */}
        <Grid item xs={12} md={6} sx={SmartLocksSectionStyles.leftSide}>
          <Box sx={SmartLocksSectionStyles.textContainer}>
            <Typography variant="h5" sx={SmartLocksSectionStyles.boldText}>
              Hardware:
            </Typography>
            <Typography variant="body1" sx={SmartLocksSectionStyles.description}>
              Visit our{' '}
              <Link href="/smart-locks" sx={SmartLocksSectionStyles.link}>
                Smart Locks & More Tab
              </Link>{' '}
              to order hardware, review hardware financing options or to confirm your existing hardware compatibility.
            </Typography>

            <Typography variant="body1" sx={SmartLocksSectionStyles.description}>
              Smart locks and additional devices arrive within three days right to your property or a nearby Amazon locker of your choice.
            </Typography>

            <Typography variant="body1" sx={SmartLocksSectionStyles.description}>
              We’ll provide easy-to-follow instructions and support for installing and connecting your devices.
            </Typography>

            <Typography variant="body1" sx={SmartLocksSectionStyles.note}>
              *All new smart access packages just $25 per month.
            </Typography>

            <Typography variant="body1" sx={SmartLocksSectionStyles.arrow}>⬇</Typography>

            <Button variant="contained" sx={SmartLocksSectionStyles.shopButton} onClick={handleShopClick}>
              SHOP SMART LOCKS AND DEVICES
            </Button>
          </Box>
        </Grid>

        {/* Right Side - White Background with Images */}
        <Grid item xs={12} md={6} sx={SmartLocksSectionStyles.rightSide}>
          <Box sx={SmartLocksSectionStyles.imageContainer}>
            <img src="/images/rental-manager/locks.png" alt="Smart Devices" style={SmartLocksSectionStyles.image} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SmartLocksSection;
